'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { Chip } from '@7f-ui/components/chip/chip';
import { ImageSliderLightbox } from '@7f-ui/components/image-slider/image-slider-lightbox';
import { SimpleModal } from '@7f-ui/components/modal/simple-modal';
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import { Images } from '@phosphor-icons/react';
import { useState } from 'react';
import type { HeroSectionProps } from '.';
import { HeroGridImage } from './hero-grid-image';
export type HeroDesktopProps = Omit<HeroSectionProps, 'mobileImages'>;
export function HeroDesktop(props) {
  const $ = _c(28);
  const isMobile = useMediaState("mobile");
  const {
    images
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = index => {
      setSelectedImageIndex(index);
      setIsOpen(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleImageClick = t0;
  if (isMobile) {
    return null;
  }
  let t1;
  if ($[1] !== images.length || $[2] !== props) {
    t1 = images.length >= 4 ? <HeroFourImages {...props} onImageClick={handleImageClick} /> : null;
    $[1] = images.length;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== images.length || $[5] !== props) {
    t2 = images.length === 3 ? <HeroThreeImages {...props} onImageClick={handleImageClick} /> : null;
    $[4] = images.length;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== images.length || $[8] !== props) {
    t3 = images.length === 2 ? <HeroTwoImages {...props} onImageClick={handleImageClick} /> : null;
    $[7] = images.length;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== images.length || $[11] !== props) {
    t4 = images.length === 1 ? <HeroOneImage {...props} onImageClick={handleImageClick} /> : null;
    $[10] = images.length;
    $[11] = props;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = <div className="fluid-container hidden h-auto grid-cols-12 grid-rows-1 pt-5 sm:grid sm:gap-4 md:gap-8">{t1}{t2}{t3}{t4}</div>;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsOpen(false);
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== images || $[20] !== selectedImageIndex) {
    t7 = <ImageSliderLightbox images={images} initialIndex={selectedImageIndex} />;
    $[19] = images;
    $[20] = selectedImageIndex;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== isOpen || $[23] !== t7) {
    t8 = <SimpleModal isOpen={isOpen} onClose={t6} size="full" height="full">{t7}</SimpleModal>;
    $[22] = isOpen;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t5 || $[26] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[25] = t5;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function HeroDecorationImage(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("col-start-2 col-end-12 row-span-1 row-start-1 row-end-2 rounded-xl bg-sand", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
type HeroImagesProps = HeroSectionProps & {
  onImageClick: (index: number) => void;
};
function HeroFourImages(t0) {
  const $ = _c(32);
  const {
    images,
    onImageClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HeroDecorationImage className="h-[95%] self-end" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onImageClick) {
    t2 = () => onImageClick(1);
    $[1] = onImageClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== images[1] || $[4] !== t2) {
    t3 = <HeroGridImage aspectRatio="square" className="col-start-1 col-end-4 mt-[34%]" onClick={t2} image={images[1]} />;
    $[3] = images[1];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onImageClick) {
    t4 = () => onImageClick(2);
    $[6] = onImageClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== images[2] || $[9] !== t4) {
    t5 = <HeroGridImage aspectRatio="square" className="z-10 col-start-3 col-end-6 mt-[15%]" onClick={t4} image={images[2]} />;
    $[8] = images[2];
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onImageClick) {
    t6 = () => onImageClick(0);
    $[11] = onImageClick;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== images[0] || $[14] !== t6) {
    t7 = <HeroGridImage aspectRatio="4/3" className="col-start-5 col-end-10 mb-6" onClick={t6} image={images[0]} priority={true} />;
    $[13] = images[0];
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onImageClick) {
    t8 = () => onImageClick(3);
    $[16] = onImageClick;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== images[3] || $[19] !== t8) {
    t9 = <HeroGridImage aspectRatio="square" className="col-start-10 col-end-13 self-end" onClick={t8} image={images[3]} />;
    $[18] = images[3];
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== onImageClick) {
    t10 = () => onImageClick(0);
    $[21] = onImageClick;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = `${images.length} Fotos anzeigen`;
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <div className="z-20 col-start-10 col-end-13 row-span-1 row-start-1 row-end-2 mr-4 flex justify-end self-end"><div className="-mb-5"><Chip variant="blank" weight="solid" IconStart={Images} onClick={t10}>{t11}</Chip></div></div>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t3 || $[28] !== t5 || $[29] !== t7 || $[30] !== t9) {
    t13 = <>{t1}{t3}{t5}{t7}{t9}{t12}</>;
    $[26] = t12;
    $[27] = t3;
    $[28] = t5;
    $[29] = t7;
    $[30] = t9;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
}
function HeroThreeImages(t0) {
  const $ = _c(20);
  const {
    images,
    onImageClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HeroDecorationImage className="mb-8 h-[85%] self-end" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onImageClick) {
    t2 = () => onImageClick(1);
    $[1] = onImageClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== images[1] || $[4] !== t2) {
    t3 = <HeroGridImage aspectRatio="4/3" className="col-start-1 col-end-5 mt-[35%]" onClick={t2} image={images[1]} />;
    $[3] = images[1];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onImageClick) {
    t4 = () => onImageClick(0);
    $[6] = onImageClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== images[0] || $[9] !== t4) {
    t5 = <HeroGridImage aspectRatio="4/3" className="z-10 col-start-4 col-end-9" onClick={t4} image={images[0]} priority={true} />;
    $[8] = images[0];
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onImageClick) {
    t6 = () => onImageClick(2);
    $[11] = onImageClick;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== images[2] || $[14] !== t6) {
    t7 = <HeroGridImage aspectRatio="4/3" className="col-start-9 col-end-13 mt-[30%]" onClick={t6} image={images[2]} />;
    $[13] = images[2];
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t5 || $[18] !== t7) {
    t8 = <>{t1}{t3}{t5}{t7}</>;
    $[16] = t3;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function HeroTwoImages(t0) {
  const $ = _c(14);
  const {
    images,
    onImageClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HeroDecorationImage className="mb-4 h-[90%] self-end" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onImageClick) {
    t2 = () => onImageClick(0);
    $[1] = onImageClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== images[0] || $[4] !== t2) {
    t3 = <HeroGridImage aspectRatio="16/9" className="col-start-1 col-end-9" onClick={t2} image={images[0]} priority={true} />;
    $[3] = images[0];
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onImageClick) {
    t4 = () => onImageClick(1);
    $[6] = onImageClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== images[1] || $[9] !== t4) {
    t5 = <HeroGridImage aspectRatio="4/3" className="z-10 col-start-8 col-end-13 mt-[25%]" onClick={t4} image={images[1]} />;
    $[8] = images[1];
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <>{t1}{t3}{t5}</>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function HeroOneImage(t0) {
  const $ = _c(5);
  const {
    images,
    onImageClick
  } = t0;
  let t1;
  if ($[0] !== onImageClick) {
    t1 = () => onImageClick(0);
    $[0] = onImageClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== images[0] || $[3] !== t1) {
    t2 = <HeroGridImage aspectRatio="16/9" className="col-start-1 col-end-13 h-112" image={images[0]} onClick={t1} priority={true} />;
    $[2] = images[0];
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}